export const calculateEAN13Checksum = (barcode) => {
  if (barcode.length !== 12) return barcode;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(barcode[i]) * (i % 2 === 0 ? 1 : 3);
  }
  const checksum = (10 - (sum % 10)) % 10;
  return barcode + checksum;
};

export const convertToEAN13 = (barcode, format) => {
  if (format === 'ean_8' && barcode.length === 8) {
    return calculateEAN13Checksum("00000" + barcode);
  } else if (format === 'upc_a' && barcode.length === 12) {
    return calculateEAN13Checksum("0" + barcode);
  } else {
    return barcode;
  }
};